import {
	DSL_ACCEPT_DARE,
	DSL_REJECT_DARE,
	DSL_DELIVER_DARE,
	DSL_OPTIONS,
	DSL_CREATE_DARE,
	DSL_SET_DARE_PINNED,
	DSL_LOAD_MORE,
} from 'root/src/shared/descriptions/endpoints/endpointIds'
import { gatewayEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'
import { authenticationTypes } from 'root/src/shared/constants/auth'

export default {
	[DSL_ACCEPT_DARE]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				projectId: { type: 'string' },
				projectUrl: { type: 'string' },
				channelId: { type: 'string' },
			},
			required: ['projectUrl', 'channelId'],
			additionalProperties: false,
		},
	},
	[DSL_REJECT_DARE]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				projectId: { type: 'string' },
				projectUrl: { type: 'string' },
				channelId: { type: 'string' },
				message: { type: 'string' },
			},
			required: ['projectUrl', 'channelId'],
			additionalProperties: false,
		},
	},
	[DSL_DELIVER_DARE]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				projectId: { type: 'string' },
				projectUrl: { type: 'string' },
				channelId: { type: 'string' },
				videoUrl: { type: 'string' },
				notes: { type: 'string' },
			},
			required: ['projectUrl', 'channelId', 'videoUrl'],
			additionalProperties: false,
		},
	},
	[DSL_OPTIONS]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				source: { type: 'string' },
				value: { type: 'string' },
				page: { type: 'integer' },
				limit: { type: 'integer' },
			},
			required: ['source'],
			additionalProperties: false,
		},
	},
	[DSL_CREATE_DARE]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				title: { type: 'string' },
				description: { type: 'string' },
				game: { type: 'string' },
				channelId: { type: 'string' },
			},
			required: ['title', 'description', 'game', 'channelId'],
			additionalProperties: false,
		},
	},
	[DSL_SET_DARE_PINNED]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				id: { type: 'string' },
				channelId: { type: 'string' },
			},
			required: ['id', 'channelId'],
			additionalProperties: false,
		},
	},
	[DSL_LOAD_MORE]: {
		authentication: authenticationTypes.optional,
		endpointType: gatewayEndpointType,
		payloadSchema: {
			type: 'object',
			properties: {
				channelId: { type: 'string' },
				tab: { type: 'string', enum: ['dares', 'giveaways'] },
				page: { type: 'integer', minimum: 1 },
			},
			required: ['channelId', 'tab', 'page'],
			additionalProperties: false,
		},
	},
}
